import TopBar from "./components/TopBar";
import UpdateTicker from "./components/UpdateTicker";
import Hero from "./components/Hero";
import NewsFlash from "./components/NewsFlash";
import HotZone from "./components/HotZone";
import Collections from "./components/Collections";
import NewsStream from "./components/NewsStream";
import Timeline from "./components/Timeline";
import DownloadCta from "./components/DownloadCta";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50 text-foreground-950">
      <TopBar />
      <UpdateTicker />

      {/* 上疏：头条区留白 */}
      <Hero />

      {/* 今日快讯 */}
      <NewsFlash />

      {/* 新瓜热榜 + 热词 */}
      <HotZone />

      {/* 题材合集 */}
      <Collections />

      {/* 下密：大图卡片流 */}
      <NewsStream />

      {/* 事件追踪时间线 */}
      <Timeline />

      {/* 下载入口醒目 */}
      <DownloadCta />

      <SiteFooter />
    </div>
  );
}